import React, { useEffect, useState } from "react";
import ImageMapper from "react-image-mapper";
import useWindowDimensions from "../../WindowSize";

export const URL =
  "/assets/repair/repair.svg";

export const MAP = {
  id: "map",
  name: "my-map",
  areas: [
    {
      id: 1,
      name: 1,
      class: 1,
      shape: "rect",
      coords: [352, 10, 564, 153],
      preFillColor: "clear"
    },
    {
      id: 2,
      name: 2,
      class: 2,
      shape: "rect",
      coords: [769, 14, 980, 150],
      preFillColor: "clear"
    },
    {
      id: 3,
      name: 3,
      class: 3,
      shape: "rect",
      coords: [1154, 10, 1371, 151],
      preFillColor: "clear"
    },
    {
      id: 4,
      name: 4,
      class: 4,
      shape: "rect",
      coords: [320, 368, 535, 509],
      preFillColor: "clear"
    },
    {
      id: 5,
      name: 5,
      class: 5,
      shape: "rect",
      coords: [1387, 307, 1600, 443],
      preFillColor: "clear"
    },
    {
      id: 6,
      name: 6,
      class: 6,
      shape: "rect",
      coords: [367, 997, 584, 1136],
      preFillColor: "clear"
    },
    {
      id: 7,
      name: 7,
      class: 7,
      shape: "rect",
      coords: [804, 1001, 1019, 1135],
      preFillColor: "clear"
    },
    {
      id: 8,
      name: 8,
      class: 8,
      shape: "rect",
      coords: [1254, 1001, 1466, 1136],
      preFillColor: "clear"
    },
    {
      id: 9,
      name: 9,
      class: 9,
      shape: "rect",
      coords: [516, 1294, 732, 1428],
      preFillColor: "clear"
    },
    {
      id: 10,
      name: 10,
      class: 10,
      href: "entry",
      shape: "rect",
      coords: [1034, 1292, 1246, 1428],
      preFillColor: "clear"
    }
  ]
};

const Repair = () => {
  const [hoveredArea, setHoveredArea] = useState(null);
  const [images, setImages] = useState({});
  const [widths, setWidth] = useState(0);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    setWidth(width);
    setImages({});
  }, [height, width]);

  function clickArea(area) {
    setImages(prevImage => ({
      ...prevImage,
      [area.id]: {
        ...area,
        show: prevImage[area.id] && !prevImage[area.id].show
      }
    }));
  }

  function enterArea(area) {
    setHoveredArea(area);
  }

  function leaveArea() {
    setHoveredArea(null);
  }

  function getTipPosition(area) {
    return { top: `${area.center[1]}px`, left: `${area.center[0]}px` };
  }

  return (
    <main className="App">
      <ImageMapper
        src={URL}
        map={MAP}
        width={width/2}
        imgWidth={1920}
        onClick={area => clickArea(area)}
        onMouseEnter={area => enterArea(area)}
        onMouseLeave={() => leaveArea()}
        fillColor="rgba(0,0,0,0)"
        strokeColor="rgba(0,0,0,0)"
        lineWidth={0}
      />
      {Object.keys(images)
        .filter(areaId => !images[areaId].show)
        .map(areaId => (
          <img
            key={areaId}
            alt="test"
            src={"/assets/ac.webp"}
            style={{
              position: "absolute",
              zIndex: 1,
              left: `${images[areaId].scaledCoords[0]}px`,
              top: `${images[areaId].scaledCoords[1]}px`,
              pointerEvents: "none",
              width: `${images[areaId].scaledCoords[2] -
                images[areaId].scaledCoords[0]}px`,
              height: `${images[areaId].scaledCoords[3] -
                images[areaId].scaledCoords[1]}px`
            }}
          />
        ))}
      {hoveredArea && (
        <span className="tooltip" style={{ ...getTipPosition(hoveredArea) }}>
          {hoveredArea && hoveredArea.name}
        </span>
      )}
    </main>
  );
}

export default Repair
